export default {
    getValidationMessage : (state)=> (validationCode)=> { 
        return (state.validationMessages.find(m => m.id == validationCode) || {}).name;
    },

    getSelectedReportType : (state)=> { 
        return state.reportTypeSelected
    },

    getFilterText : (state)=> { 
        return state.filterText
    }
}